export const checkAllTaxSituationComplete = (
  filing,
  documents,
  services,
  dependents,
) => {
  const m = filing.summary_metrics;
  if (!m) return false;

  // 1. Check PTF Sections
  if (services.includes("PTF")) {
    const ptfIncomeComplete = m.income_sources_ptf?.complete ?? true;
    const ptfCreditsComplete = m.credits_deductions_ptf?.complete ?? true;
    const ptfInsuranceComplete = m.insurance_ptf?.complete ?? true;
    const dependentsComplete = m.dependents?.complete ?? true;

    if (
      !ptfIncomeComplete ||
      !ptfCreditsComplete ||
      !ptfInsuranceComplete ||
      !dependentsComplete
    ) {
      return false;
    }
  }

  // 2. Check BTF Sections
  if (services.includes("BTF")) {
    const btfComplete = m.business_documents_btf?.complete ?? true;
    if (!btfComplete) return false;
  }

  // 3. Final safety check: Is the user required to do anything else?
  // We check if any of the taxpayer sections say 'attention_needed_cus'
  const taxpayerNeedsAttention =
    m.income_sources_ptf?.attention_needed_cus ||
    m.credits_deductions_ptf?.attention_needed_cus ||
    m.insurance_ptf?.attention_needed_cus ||
    m.dependents?.attention_needed_cus ||
    m.business_documents_btf?.attention_needed_cus;

  if (taxpayerNeedsAttention) return false;

  return true;
};
